export enum YearlyMonthly {
  Yearly = 'yearly',
  Monthly = 'monthly'
}
